import * as React from "react";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import TonalityIcon from "@mui/icons-material/Tonality";
import { styled } from "@mui/material/styles";
import { ReactComponent as LogoSvg } from "./logo.svg";
import LocalMoviesIcon from "@mui/icons-material/LocalMovies";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import PaletteIcon from "@mui/icons-material/Palette";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { useContext } from "react";
import MainContext from "../../../context/mainContext";
import RttIcon from "@mui/icons-material/Rtt";

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "absolute",
  "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
    top: theme.spacing(2),
    left: theme.spacing(2),
  },
}));

export default function BasicSpeedDial(props) {
  const {
    handleShowSubtitleStyleBox,
    handleFullScreen,
    handleOpenSelectSubtitlesBox,
    handleOpenSelectVideoBox,
    handleSemiAutoShadowing,
  } = props;
  const { handleSubtitleTimeShiftBox, subtitleTimeShiftBox } =
    useContext(MainContext);

  const actions = [
    {
      icon: <LocalMoviesIcon onClick={handleOpenSelectVideoBox} />,
      name: "انتخاب فیلم",
    },
    {
      icon: <ClosedCaptionIcon onClick={handleOpenSelectSubtitlesBox} />,
      name: "انتخاب زیرنویس",
    },
    {
      icon: <PaletteIcon onClick={handleShowSubtitleStyleBox} />,
      name: "استایل زیرنویس",
    },
    {
      icon: (
        <RttIcon
          onClick={() => {
            handleSubtitleTimeShiftBox(!subtitleTimeShiftBox);
          }}
        />
      ),
      name: "ویرایش زمان زیرنویس",
    },
    {
      icon: (
        <TonalityIcon
          onClick={() => {
            handleSemiAutoShadowing("showSettings");
          }}
        />
      ),
      name: "تکنیک سایه",
    },
    {
      icon: <FullscreenExitIcon onClick={handleFullScreen.exit} />,
      name: "خروج از تمام صفحه",
    },
  ];
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        display: handleFullScreen.active ? "block" : "none",
      }}
      //  sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}
    >
      <StyledSpeedDial
        ariaLabel="SpeedDial playground example"
        //   hidden={hidden}
        color="error"
        icon={<LogoSvg sx={{ p: 0, m: 0, color: "red" }} />}
        direction={"right"}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
          />
        ))}
      </StyledSpeedDial>
    </Box>
  );
}
